module.exports = __webpack_public_path__ + "media/images/talent/lp/case02-0214e3a977bf4bc4b83b68cca76985e8.png";